module.exports = __webpack_public_path__ + "img/badge_color_cap-exploration.8362943a.svg";